import MainNav from "../components/mainNav";
import SideNavBody from "../components/sideNavBody";

const WatchLater = ({title}) => {
    return ( 
        <main>
            <MainNav />
            <SideNavBody title={title}/>
        </main>
     );
}
 
export default WatchLater;